import { axiosInstance } from "lib/axios"
import { searchAPI } from "services/apis.service";

export const fetchReadingLevel = async (requestBody) => {
    const { data } = await axiosInstance.post(
      searchAPI.readingLevel,
      requestBody,
      {
        cache: false,
      }
    );

    return data;
}